const deprecatedIcons = {
  users: 'users2',
  invoicing: 'invoice',
  grid: 'dashboard'
};

/**
 * Get the icon component (class) for the navItem
 *
 * @param {object} navItem - Navigation item
 * @param {string} [navItem.icon] - Unique icon name
 * @param {boolean} [navItem.active] - True if the item is active
 * @returns {string} The icon name to be used
 */
export const getIconName = (navItem) => {
  // TODO: remove next line after partners update their deprecated icons
  // JIRA: https://godaddy-corp.atlassian.net/browse/UXP-8698
  const iconName = deprecatedIcons[navItem.icon] || navItem.icon;

  return iconName;
};
